"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CopyPlugin_1 = require("../corePlugins/CopyPlugin");
var CorePastePlugin_1 = require("../corePlugins/CorePastePlugin");
var DOMEventPlugin_1 = require("../corePlugins/DOMEventPlugin");
var EditPlugin_1 = require("../corePlugins/EditPlugin");
var FirefoxTypeAfterLink_1 = require("../corePlugins/FirefoxTypeAfterLink");
var MouseUpPlugin_1 = require("../corePlugins/MouseUpPlugin");
var TypeInContainerPlugin_1 = require("../corePlugins/TypeInContainerPlugin");
var Undo_1 = require("../undo/Undo");
var attachDomEvent_1 = require("../coreAPI/attachDomEvent");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var calculateDefaultFormat_1 = require("../coreAPI/calculateDefaultFormat");
var createPasteFragment_1 = require("../coreAPI/createPasteFragment");
var editWithUndo_1 = require("../coreAPI/editWithUndo");
var focus_1 = require("../coreAPI/focus");
var getCustomData_1 = require("../coreAPI/getCustomData");
var getSelectionRange_1 = require("../coreAPI/getSelectionRange");
var getStyleBasedFormatState_1 = require("../coreAPI/getStyleBasedFormatState");
var hasFocus_1 = require("../coreAPI/hasFocus");
var insertNode_1 = require("../coreAPI/insertNode");
var selectRange_1 = require("../coreAPI/selectRange");
var triggerEvent_1 = require("../coreAPI/triggerEvent");
/**
 * Create core object for editor
 * @param contentDiv The DIV element used for editor
 * @param options Options to create an editor
 */
function createEditorCore(contentDiv, options) {
    var corePlugins = {
        undo: options.undo || new Undo_1.default(),
        edit: new EditPlugin_1.default(),
        typeInContainer: new TypeInContainerPlugin_1.default(),
        mouseUp: new MouseUpPlugin_1.default(),
        domEvent: new DOMEventPlugin_1.default(options.disableRestoreSelectionOnFocus),
        firefoxTypeAfterLink: new FirefoxTypeAfterLink_1.default(),
        copyPlugin: !roosterjs_editor_dom_1.Browser.isIE && new CopyPlugin_1.default(),
        pastePlugin: new CorePastePlugin_1.default(),
    };
    var allPlugins = buildPluginList(corePlugins, options.plugins);
    var eventHandlerPlugins = allPlugins.filter(function (plugin) { return plugin.onPluginEvent || plugin.willHandleEventExclusively; });
    return {
        contentDiv: contentDiv,
        scrollContainer: options.scrollContainer || contentDiv,
        document: contentDiv.ownerDocument,
        defaultFormat: calculateDefaultFormat_1.calculateDefaultFormat(contentDiv, options.defaultFormat, options.inDarkMode),
        corePlugins: corePlugins,
        currentUndoSnapshot: null,
        customData: createCustomData(options.customData || {}),
        cachedSelectionRange: null,
        plugins: allPlugins,
        eventHandlerPlugins: eventHandlerPlugins,
        api: createCoreApiMap(options.coreApiOverride),
        defaultApi: createCoreApiMap(),
        inDarkMode: options.inDarkMode,
        darkModeOptions: options.darkModeOptions,
    };
}
exports.default = createEditorCore;
function buildPluginList(corePlugins, plugins) {
    return __spreadArrays([
        corePlugins.typeInContainer,
        corePlugins.edit,
        corePlugins.mouseUp
    ], (plugins || []), [
        corePlugins.firefoxTypeAfterLink,
        corePlugins.undo,
        corePlugins.domEvent,
        corePlugins.copyPlugin,
        corePlugins.pastePlugin,
    ]).filter(function (plugin) { return !!plugin; });
}
function createCoreApiMap(map) {
    map = map || {};
    return {
        attachDomEvent: map.attachDomEvent || attachDomEvent_1.attachDomEvent,
        editWithUndo: map.editWithUndo || editWithUndo_1.editWithUndo,
        focus: map.focus || focus_1.focus,
        getCustomData: map.getCustomData || getCustomData_1.getCustomData,
        getSelectionRange: map.getSelectionRange || getSelectionRange_1.getSelectionRange,
        getStyleBasedFormatState: map.getStyleBasedFormatState || getStyleBasedFormatState_1.getStyleBasedFormatState,
        hasFocus: map.hasFocus || hasFocus_1.hasFocus,
        insertNode: map.insertNode || insertNode_1.insertNode,
        createPasteFragment: map.createPasteFragment || createPasteFragment_1.createPasteFragment,
        select: map.select || selectRange_1.select,
        selectRange: map.selectRange || selectRange_1.selectRange,
        triggerEvent: map.triggerEvent || triggerEvent_1.triggerEvent,
    };
}
function createCustomData(initValue) {
    return Object.keys(initValue).reduce(function (result, key) {
        result[key] = {
            value: initValue[key],
        };
        return result;
    }, {});
}
//# sourceMappingURL=createEditorCore.js.map